<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">Help Videos</h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="custom-body">
        <div class="row">
          <div class="col-3">
            <ul class="custom-list">
              <li
                v-for="item in videos"
                :key="item.id"
                :class="{ 'custom-selected': selected === item.id }"
                @click="selectVideo(item)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="col-9 custom-video">
            <vimeo-player
              :playerHeight="videoHeight"
              :playerWidth="videoWidth"
              :video-id="videoid"
              :video-url="videolink"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1"></div>
        <div class="col-md-6">
          <z-message
            v-model="notice"
            :timeout="3000"
            class="alert alert-warning"
          />
        </div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import VimeoPlayer from '@/Components/ZElements/VimeoPlayer'
import ZDialog from '@/Components/ZElements/Dialog'
import ZMessage from '@/Components/ZElements/Message'
export default {
  name: 'help-videos',
  components: {
    ZDialog,
    ZMessage,
    VimeoPlayer,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
      notice: '',
      isSave: false,
      video: null,
      videoid: '0',
      videolink: '',
      videoHeight: 480,
      videoWidth: null,
      selected: null,
    }
  },
  async mounted() {
    await this.getVideos()
  },
  computed: {
    ...mapGetters('configuration', ['settings']),
    isVisible() {
      return this.show !== null
    },
    videos() {
      let _videos = []
      if (this.settings) {
        this.settings.forEach((element) => {
          let id = null
          if (element.TextValue) {
            id = element.TextValue.replace('https://vimeo.com/', '')
          }
          _videos.push({
            id: element.id,
            name: element.Name,
            url: element.TextValue,
            videoId: id,
          })
        })
      }
      console.log('List of Videos', _videos)
      return _videos
    },
    // videolink() {
    //   let _url = null
    //   if (this.video) {
    //     _url = this.video.url
    //   }
    //   return _url
    // },
  },
  methods: {
    ...mapActions('configuration', ['getSettings']),
    showMessage(msg) {
      this.notice = msg
    },
    close() {
      this.$emit('close')
    },
    selectVideo(item) {
      // this.video = item
      if (item) {
        this.videolink = item.url
        // this.videoid = item.videoId
        this.selected = item.id
        window.app.$forceUpdate()
      }
    },
    async getVideos() {
      await this.getSettings({
        page: 1,
        pageSize: 999,
        sortBy: 'id',
        orderBy: 'asc',
        search: '',
        filter: 'HelpVideo',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 700px;
  height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-list {
  list-style: none;
  li {
    cursor: pointer;
    margin-top: 3px;
    margin-bottom: 3px;
    padding: 2px;
  }
  li:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
.custom-selected {
  background-color: rgba(0, 0, 0, 0.2);
}
.custom-video {
  border: 1px solid rgb(189, 189, 189);
  border-radius: 5px;
  padding-right: 15px;
  min-height: 480px;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-check {
  position: relative;
  top: 30px;
  left: 15px;
  label {
    margin-left: 5px;
  }
}
</style>
